import './styles/Card.scss';
import PropTypes from "prop-types";
import React from 'react';
import {Link} from "react-router";

const Card = ({children, editLink, icon, onDelete}) => {


  return (
    <div className="sp-profile-card">
      {icon && (<div className="sp-profile-card-icon">{icon()}</div>)}

      <div className="sp-profile-card-content">{children}</div>

      <div className="sp-profile-card-actions">
        {editLink && (
          <Link to={editLink} className="btn btn-outline-primary">Edit Information</Link>
        )}

        {onDelete && (
          <button className="btn btn-outline-danger" onClick={onDelete}>Delete</button>
        )}
      </div>
    </div>
  );
};

Card.defaultProps = {
  icon: () => (<React.Fragment/>)
}

Card.propTypes = {
  person: PropTypes.shape({
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
  }),

  /** Link to the route to edit the entity */
  editLink: PropTypes.string,

  /** Function to display icon */
  icon: PropTypes.func,

  /** Function to delete the entity */
  onDelete: PropTypes.func,
};

export default Card;
